import { createContext } from "react";

export const RematchContext = createContext(null);
